const defaultConfig = {
  itemsKey: "multi_tiles",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props: (*&{title: (*|null), items: *})}|null}
 */
export const multiTiles = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "MultiTiles",
    props: {
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
        img: i.image ?? "",
        href: i.link ?? null,
      })),
      ...props,
    },
  };
};
